
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { estateAgentService } from '@/estate-agent/EstateAgentService';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import EstateAgentLanguage from '@/estate-agent/components/EstateAgentLanguage.vue';

export default defineComponent({
  name: 'EstateAgentProfile',
  mixins: [Form],
  components: {
    ResizableImage,
    EstateAgentLanguage,
  },
  data() {
    return {
      profile: {},
    };
  },
  async created() {
    this.isLoading = true;
    try {
      const result = await estateAgentService.getProfile();
      this.profile = result.data;
    } catch (error) {
      console.error(error);
    }
  },
  methods: {},
});
